module.exports = __webpack_public_path__ + "img/Icon-Pfeil-hoch.6827fc71.svg";